import React, { Component } from 'react'
import { object, bool } from 'prop-types'
import { connect } from 'react-redux'
import dl from 'downloadjs'
import { download } from 'utils/network'

import Side from './side'
import Summary from './summary'
import { fetchCashiers, fetchReport } from './actions'

class Collections extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cashiers: [],
      downloading: false,
    }
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchCashiers())
      .then((res) => {
        if (!res.error) {
          const cashiers = []
          res.payload.map((item) => {
            cashiers.push({
              label: item.name,
              value: item.id,
            })
            return true
          })
          this.setState({ cashiers })
        }
      })
  }

  _onSubmit = (payload) => {
    let mod = payload.set('date_from', payload.get('date_from').format('L'))
    mod = mod.set('date_to', mod.get('date_to').format('L'))
    // retrieve data
    this.props.dispatch(fetchReport(mod))
  }

  _onDownload = () => {
    this.setState({
      downloading: true,
    })
    const { __state } = this.props
    let mod = __state.set('date_from', __state.get('date_from').format('L'))
    mod = mod.set('date_to', mod.get('date_to').format('L'))
    download('/reports/collections/download', mod.toJS())
      .then((res) => {
        this.setState({
          downloading: false,
        })
        dl(res, 'collection_report.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      })
  }

  render() {
    const { cashiers, downloading } = this.state
    const { __state, __data, __pending } = this.props

    return (
      <div className="row">
        <div className="col-sm-3">
          <Side
            filters={__state}
            cashiers={cashiers}
            onSubmit={this._onSubmit}
            pending={__pending}
          />
        </div>
        <div className="col-sm-9">
          <Summary
            data={__data}
            pending={__pending}
            onDownload={this._onDownload}
            downloading={downloading}
          />
        </div>
      </div>
    )
  }
}

Collections.propTypes = {
  __state: object,
  __data: object,
  __pending: bool,
}

function mapStateToProps(state) {
  return {
    __state: state.collectionState,
    __data: state.collection.get('data'),
    __pending: state.collection.get('pending'),
  }
}

export default connect(mapStateToProps)(Collections)



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/index.js